import { useEffect, useState } from 'react';
import { useUser } from '@clerk/clerk-react';
import { supabase } from './supabase';

export function useWhitelistRole() {
  const { user, isLoaded } = useUser();
  const email = user?.primaryEmailAddress?.emailAddress || null;
  const [entry, setEntry] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isLoaded) return;
    if (!email) {
      setEntry(null);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setError(null);
    console.log('[whitelist] checking email:', email);
    supabase
      .from('whitelist')
      .select('rol, activo, nombre')
      .eq('email', email)
      .maybeSingle()
      .then(({ data, error: qErr }) => {
        if (cancelled) return;
        if (qErr) {
          console.error('[whitelist] query error:', qErr);
          setError(qErr.message || 'whitelist query failed');
          setEntry(null);
          setLoading(false);
          return;
        }
        console.log('[whitelist] result for', email, '→', data || '(not found)');
        setEntry(data || null);
        setLoading(false);
      });
    return () => { cancelled = true; };
  }, [isLoaded, email]);

  const role = entry?.rol ?? null;
  const active = entry?.activo !== false;
  const authorized = !!entry && active;
  return {
    role,
    isAdmin: role === 'admin',
    nombre: entry?.nombre ?? null,
    email,
    loading,
    error,
    authorized,
  };
}
